@if ((tableModel$ | async); as tableModel) {
  <p-table [scTableSettings]="tableModel.tableSettings">
    @if (tableModel.hasChapters && !tableModel.isReadonly; as rowData) {
      <ng-template pTemplate="row-actions"
                   let-rowData>
        <p-button styleClass="p-button-rounded p-button-text"
                  icon="fas fa-pen"
                  (onClick)="openChapterTopicsDialog(rowData)"
                  pTooltip="Click to update topics"
                  tooltipPosition="top"
                  i18n-pTooltip>
        </p-button>
      </ng-template>
    }
  </p-table>
}